import React from 'react';
import {
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  Heading,
  Text,
  Button,
  Flex,
  ModalFooter,
} from '@televet/kibble-ui';

interface IImportantNoticeModalProps {
  onClose: () => void;
  isOpen: boolean;
  loading: boolean;
  confirmCallback: (data: any) => void; //eslint-disable-line
  cancelCallback: (data: any) => void; //eslint-disable-line
}

const ImportantNoticeModal = ({
  onClose,
  isOpen,
  loading,
  confirmCallback,
  cancelCallback,
}: IImportantNoticeModalProps): JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalHeader>
        <Flex>
          <Icon name="warningSign" variant="warning" />
          <Heading size="md" pl={2}>
            Important Notice
          </Heading>
        </Flex>
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Text>
          Navigating away from this invoice will cancel it and clear your saved progress. Are you sure you want to do
          this?
        </Text>
      </ModalBody>
      <ModalFooter>
        <Flex justifyContent="space-between" width="100%">
          <Button onClick={cancelCallback} variant="tertiary">{`No, go back`}</Button>
          <Button onClick={confirmCallback} isLoading={loading}>{`Yes, I'm sure`}</Button>
        </Flex>
      </ModalFooter>
    </Modal>
  );
};

export default ImportantNoticeModal;
